module.exports = {
    ResizeSensor: require('./src/ResizeSensor'),
    ElementQueries: require('./src/ElementQueries')
};



//////////////////
// WEBPACK FOOTER
// ./~/css-element-queries/index.js
// module id = 1622
// module chunks = 1 2 3